(() => {
'use strict';
const copy={de:{preview:'',note:'Demo · Keine Anmeldung, kein gültiger Code',close:'Schließen',tag:'SOMETHING GOOD IS HIDDEN HERE',title:'WAS STECKT<br>FÜR DICH DRIN?',sub:'Decke 3 Karten auf und sichere dir deinen Mystery-Rabatt.',launcher:'MYSTERY-RABATT',rewardLabel:'RABATT',card:'Karte',count:n=>`${n} / 3`,next:'WEITER',unlock:'WEITER',emailTitle:'FAST GESCHAFFT.',emailSub:'',email:'E-Mail',placeholder:'du@beispiel.de',consent:'Mit deiner Anmeldung abonnierst du den warpedsense Newsletter mit Angeboten und Produktneuheiten per E-Mail. Du kannst dich jederzeit abmelden.',privacy:'Datenschutz',reveal:'CODE SICHERN',demo:'Testadresse nutzen',back:'Zurück',success:'DEIN RABATT.',first:'auf deine erste Bestellung',code:'Vorschau-Code · nicht einlösbar',again:'NOCH EINMAL ANSEHEN',aTitle:'10% FÜR DICH.',aSub:'Auf deine erste Bestellung.',aCta:'10% SICHERN',foot:'Dein Rabattcode kommt nach der Anmeldung per E-Mail.',selection:'Ausgewählt',disclaimer:''},en:{preview:'',note:'Demo · No signup, no valid code',close:'Close',tag:'SOMETHING GOOD IS HIDDEN HERE',title:'WHAT’S YOUR<br>MYSTERY OFFER?',sub:'Reveal 3 cards and claim your mystery discount.',launcher:'MYSTERY DISCOUNT',rewardLabel:'OFF',card:'Card',count:n=>`${n} / 3`,next:'CONTINUE',unlock:'CONTINUE',emailTitle:'ALMOST THERE.',emailSub:'',email:'Email',placeholder:'you@example.com',consent:'By signing up, you subscribe to the warpedsense newsletter with offers and product updates by email. You can unsubscribe at any time.',privacy:'Privacy',reveal:'GET MY CODE',demo:'Use test email',back:'Back',success:'YOUR DISCOUNT.',first:'off your first order',code:'Preview code · not redeemable',again:'TRY IT AGAIN',aTitle:'GET 10% OFF.',aSub:'Your first order.',aCta:'GET 10% OFF',foot:'Your discount code arrives by email after signup.',selection:'Selected',disclaimer:''}};

const cfg = window.WSMysteryConfig;
if (!cfg || window.WSMystery || (!cfg.enabled && !cfg.preview)) return;
const id='ws_mystery_cards_v2', params=new URLSearchParams(location.search);
const manualRequested=false;
if (/\/password|black-friday-early-access/.test(location.pathname)) return;
const store={get(k){try{return JSON.parse(localStorage.getItem(k))}catch{return null}},set(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch{}}};
if(!cfg.preview){try{localStorage.setItem(id+'_probe','1');localStorage.removeItem(id+'_probe')}catch{return}}
// Peter1799: one Mystery experience for everyone; migrate former control visitors.
const variant='B';
if(!cfg.preview && store.get(id)?.variant!=='B')store.set(id,{variant,created:Date.now()});
const lang=String(cfg.lang).startsWith('de')?'de':'en', nativeId=lang==='de'?'Up4eiE':'QSmdAc';
// Keep review dismissals across navigation without changing the live experiment.
const dismissalId=id+(cfg.preview?'_preview':'');
const commonTriggers=true;
const anyPopupKey=dismissalId+'_any_popup_shown';
let teaserDismissed=store.get(dismissalId+'_teaser_closed')>Date.now()-3*86400000;
const requestId=id+(cfg.preview?'_preview':'')+'_requested';
let requestedThisPage=false;
// In-memory only: preserve request id on retries, never persist the email.
let pendingSubmission=null;
const signupRequested=()=>requestedThisPage||Boolean(store.get(requestId));
const hasAnalyticsConsent=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
let viewed=false,viewTracked=false,nativeAllowed=false,nativeOpening=false,internalNativeClose=false,triggerPending=false;
// Funnel v2: fixed metadata only; never send field values or free-form error text.
function marketContext(){
 const storefront=String(window.Shopify?.routes?.root||cfg.shopRoot||'/').replace(/\/$/,'')||'/';
 return {market:lang==='de'?'DACH':storefront==='/en-us'?'US':storefront==='/en-int'?'INT':'UNKNOWN',storefront};
}
function track(name,extra={}){
 if(cfg.preview||!hasAnalyticsConsent())return false;
 const context=marketContext();
 const detail={experiment_id:id,variant,language:lang,market:context.market,storefront:context.storefront,store_country:cfg.country,currency:cfg.currency,content_group:'mystery_'+context.market,tracking_version:'2',step,cards_selected:picked.size,open_method:openMethod,...extra};
 try{window.dispatchEvent(new CustomEvent('wsMysteryAnalytics',{detail:{name,...detail}}))}catch{}
 try{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'ws_mystery_'+name,...detail})}catch{}
 try{if(typeof window.gtag==='function'){
  window.gtag('set','user_properties',{ws_mystery_experiment:id,ws_mystery_variant:variant});
  window.gtag('event','ws_mystery_'+name+'_'+variant.toLowerCase(),{...detail,send_to:'G-6YVW75C6NM'});
 }}catch{}
 try{window.Shopify?.analytics?.publish('ws_mystery_'+name,detail)?.catch?.(()=>{})}catch{}
 return true;
}
function trackOnce(name,extra={}){
 if(funnelTracked.has(name))return;
 if(track(name,extra))funnelTracked.add(name);
}
function trackVisibleStep(){
 if(!dialog.open)return;
 trackOnce('popup_open');
 if(step==='email')trackOnce('email_view');
 if(step==='success')trackOnce('success_view');
}
function abandon(reason){
 if(!dialog.open||step==='success'||abandonTracked)return;
 abandonTracked=track('abandon',{reason,submission_pending:submitting});
}
function exposure(){
 viewed=true;
 if(!viewTracked&&hasAnalyticsConsent()&&!cfg.preview){
  viewTracked=true;track('view');
  // Private cart attributes provide order attribution without exposing contact data.
  const root=String(window.Shopify?.routes?.root||cfg.shopRoot||'/').replace(/\/$/,'');
  fetch(root+'/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({attributes:{ws_mystery_experiment__:id,ws_mystery_variant__:variant}})}).catch(()=>{});
 }
}
if(cfg.subscriber&&!cfg.preview)return;
const host=document.createElement('div');host.id='ws-mystery-root';
const root=host.attachShadow({mode:'open'});
const styleLink=document.createElement('link');styleLink.rel='stylesheet';styleLink.href=cfg.css;
root.append(styleLink);
const langCopy={de:{emailTitle:'SICHERE DIR<br>DEINEN CODE.',reveal:'CODE SICHERN',success:'CHECK DEINE MAILS.',done:'WEITER SHOPPEN',error:'Das hat nicht geklappt. Bitte versuche es erneut.',slow:'Bitte kurz warten und erneut versuchen.',previewNote:'Vorschau · Anmeldung simuliert',close:'Schließen'},en:{emailTitle:'GET YOUR<br>DISCOUNT CODE.',reveal:'GET MY CODE',success:'CHECK YOUR EMAILS.',done:'KEEP SHOPPING',error:'Something went wrong. Please try again.',slow:'Please wait a moment and try again.',previewNote:'Preview · Simulated signup',close:'Close'}};
Object.assign(copy[lang],langCopy[lang]);const c=copy[lang];
const dialog=document.createElement('dialog');dialog.setAttribute('aria-labelledby','heading');
dialog.innerHTML='<div class="modal-top"><img alt="warpedsense" width="600" height="99"><button class="close" type="button">×</button></div><div class="content"></div>';
dialog.querySelector('img').src=cfg.logo;dialog.querySelector('.close').setAttribute('aria-label',c.close);root.append(dialog);
const content=dialog.querySelector('.content'), $=s=>root.querySelector(s), $$=s=>root.querySelectorAll(s);
const cmpExpected=Boolean(window.pandectesBannerSettings||document.querySelector('script[src*="pandectes"]'));
let privacyReady=!cmpExpected,privacyPending=cmpExpected,privacySeen=false,pendingOpen=null;
const watchedCMP=new WeakSet();
function cookieDialogVisible(){
 return [...document.querySelectorAll('pandectes-cmp')].some(el=>[...(el.shadowRoot?.querySelectorAll('dialog[open],[role="dialog"],.dialog')||[])].some(d=>d.getClientRects().length&&getComputedStyle(d).visibility!=='hidden'));
}
function privacyBlocked(){return !privacyReady||privacyPending||cookieDialogVisible()}
function refreshPrivacy(){
 document.querySelectorAll('pandectes-cmp').forEach(el=>{
  if(el.shadowRoot&&!watchedCMP.has(el)){watchedCMP.add(el);new MutationObserver(refreshPrivacy).observe(el.shadowRoot,{childList:true,subtree:true,attributes:true,attributeFilter:['open','hidden','class','style']})}
 });
 if(cookieDialogVisible()){privacySeen=true;privacyReady=true;if(dialog.open||nativeAllowed)close()}
 else if(privacySeen){privacyPending=false}
 if(!privacyBlocked()&&pendingOpen!==null){const automatic=pendingOpen;pendingOpen=null;requestAnimationFrame(()=>open(automatic))}
 syncNative();
}
window.addEventListener('PandectesInitialized',e=>{
 privacyReady=true;privacyPending=e.detail?.banner===true&&e.detail?.preferences==null;refreshPrivacy();
});
window.addEventListener('PandectesConsentUpdate',()=>{privacyReady=true;privacyPending=false;refreshPrivacy();if(dialog.open){exposure();trackVisibleStep()}});
let automaticHandled=false;
let step='cards',picked=new Set(),timer=null,submitting=false,controller=null,previousFocus=null,openedAt=0;
let openMethod='automatic',funnelTracked=new Set(),abandonTracked=false;
const clearTimer=()=>{clearTimeout(timer);timer=null};
const heading=(title,sub='')=>`<h2 class="title" id="heading" tabindex="-1">${title}</h2>${sub?`<p class="sub">${sub}</p>`:''}`;
function render(){
 content.className='content step';
 if(step==='cards'){
 content.innerHTML=heading(c.title,c.sub)+`<div class="scene"><div class="cards">${[0,1,2,3].map(i=>`<button type="button" class="card" data-card="${i}" aria-label="${c.card} ${i+1}" aria-pressed="false"><span class="card-inner"><span class="face front" aria-hidden="true"><span class="card-number">0${i+1}</span><span class="orbit"></span><span class="orbit two"></span><span class="question">?</span></span><span class="face back" aria-hidden="true"><span class="tick">✓</span><span class="star">✦</span><span class="mystery">MYSTERY<br>DISCOUNT</span></span></span></button>`).join('')}</div></div><div class="progress" aria-hidden="true"><i></i><i></i><i></i></div><p class="counter" role="status" aria-live="polite">0 / 3</p>`;
 $('.scene').style.backgroundImage=`linear-gradient(#15151544,#15151577),url("${cfg.hero}")`;
 $$('[data-card]').forEach(b=>b.onclick=()=>pick(b));
 }else if(step==='email'){
 content.innerHTML=heading(c.emailTitle,c.foot)+`<div class="selected-art" aria-hidden="true"><div class="mini-card"><span>✦</span>MYSTERY DISCOUNT</div></div><form id="signup"><label class="email" for="email">${c.email}</label><input id="email" name="email" type="email" autocomplete="email" inputmode="email" placeholder="${c.placeholder}" required maxlength="254"><div class="trap" aria-hidden="true"><label>Website<input name="website" tabindex="-1" autocomplete="off"></label></div><p class="consent" id="signup-consent">${c.consent} <a target="_blank" rel="noopener noreferrer">${c.privacy}</a>.</p><p class="error" id="error" role="alert" hidden></p><button class="primary" type="submit" aria-describedby="signup-consent">${c.reveal}</button></form>`;
 $('.consent a').href=cfg.privacy;$('#signup').onsubmit=submit;
  $('#email').addEventListener('focus',()=>trackOnce('email_focus'));
  $('#email').addEventListener('input',()=>{if($('#email').value.length)trackOnce('input_start')});
  $('#email').addEventListener('invalid',()=>track('signup_error',{error_type:'invalid_email'}));
 }else{
 content.innerHTML=heading(c.success)+`<div class="inbox" aria-hidden="true">✉</div><button class="primary" id="done">${c.done}</button>`;$('#done').onclick=close;
 }
 dialog.scrollTop=0;requestAnimationFrame(()=>$('#heading')?.focus({preventScroll:true}));
}
function pick(button){
 const n=Number(button.dataset.card);if(picked.has(n)||picked.size>=3)return;
 picked.add(n);track('card_click',{card_index:n+1});button.classList.add('flipped');button.disabled=true;button.setAttribute('aria-pressed','true');button.setAttribute('aria-label',`${c.card} ${n+1}: ${c.selection}`);
 $('.counter').textContent=`${picked.size} / 3`;$$('.progress i').forEach((x,i)=>x.classList.toggle('on',i<picked.size));
 if(picked.size===3){$$('[data-card]').forEach(b=>b.disabled=true);timer=setTimeout(()=>{if(dialog.open&&step==='cards')go('email')},matchMedia('(prefers-reduced-motion: reduce)').matches?0:650)}
}
function go(next){clearTimer();step=next;render();trackVisibleStep()}
function nativeEligible(){return cfg.preview||Boolean(document.querySelector('.kl-teaser-'+nativeId))}
function blocked(automatic){
 return teaserDismissed||signupRequested()||(!cfg.preview&&cfg.subscriber)||
 (automatic&&(automaticHandled||store.get(dismissalId+'_closed')>Date.now()-3*86400000||store.get(dismissalId+'_shown')>Date.now()-3*86400000||store.get(anyPopupKey)>Date.now()-86400000));
}
function markShown(){store.set(dismissalId+'_shown',Date.now());store.set(anyPopupKey,Date.now());exposure()}
function open(automatic=false){
 if(blocked(automatic)||!nativeEligible())return;
 if(teaserDismissed||signupRequested())return;
 if(privacyBlocked()){pendingOpen=automatic===true;return}
 if(automatic===true&&automaticHandled)return;
 if(automatic===true&&store.get(dismissalId+'_closed')>Date.now()-3*86400000)return;
 if(automatic===true&&commonTriggers&&(store.get(dismissalId+'_shown')>Date.now()-3*86400000||store.get(anyPopupKey)>Date.now()-86400000))return;
 if(variant==='A'){
  if(nativeOpening||(nativeAllowed&&nativeModal()))return;
  nativeOpening=true;nativeAllowed=true;
  document.documentElement.setAttribute('data-ws-native-allowed','true');
  window._klOnsite=window._klOnsite||[];window._klOnsite.push(['openForm',nativeId]);
  // A slow native script may render after this window; do not revoke its open permission.
  setTimeout(()=>{nativeOpening=false},3000);
  return;
 }
 if(dialog.open)return;
 openMethod=automatic===true?'automatic':'manual';funnelTracked=new Set();abandonTracked=false;
 previousFocus=document.activeElement;step='cards';picked=new Set();openedAt=Date.now();render();dialog.showModal();markShown();trackVisibleStep();
}
function close(){
 if(variant==='A'){
  nativeModal()?.querySelector('button[aria-label="Close dialog"]')?.click();
  nativeAllowed=false;nativeOpening=false;document.documentElement.removeAttribute('data-ws-native-allowed');
  return;
 }
 const wasOpen=dialog.open;
 if(wasOpen){abandon('close');track('close')}
 automaticHandled=true;
 if(dialog.open)store.set(dismissalId+'_closed',Date.now());
 clearTimer();controller?.abort();controller=null;submitting=false;
 if($('#email'))$('#email').value='';dialog.close();content.replaceChildren();
 const fallback=document.querySelector('.kl-teaser-'+nativeId+' [role="button"]');
 (previousFocus?.isConnected?previousFocus:fallback)?.focus?.({preventScroll:true});
}
async function submit(e){
 e.preventDefault();const form=e.currentTarget;if(submitting||!form.reportValidity())return;
 if(form.elements.website.value)return;
 const email=form.elements.email.value.trim();if(!email||email.length>254)return;
 track('signup_attempt');
 submitting=true;const button=form.querySelector('[type="submit"]');button.disabled=true;button.setAttribute('aria-busy','true');$('#error').hidden=true;
 // Selected storefront context, never a claim about residence or citizenship.
 const shopRoot=String(window.Shopify?.routes?.root||cfg.shopRoot||'/').replace(/\/$/,'')||'/';
 const market=lang==='de'?'DACH':shopRoot==='/en-us'?'US':shopRoot==='/en-int'?'INT':null;
 if(!market||!cfg.country||!/^[A-Z]{3}$/.test(cfg.currency||'')){
  track('signup_error',{error_type:'routing_unavailable'});
  $('#error').textContent=c.error;$('#error').hidden=false;
  submitting=false;button.disabled=false;button.removeAttribute('aria-busy');return;
 }
 const properties={ws_signup_experience:'mystery_cards_v1',ws_signup_variant:'B',ws_signup_experiment:id,ws_signup_language:lang,ws_signup_store_country:cfg.country,ws_signup_market:market,ws_signup_currency:cfg.currency,ws_signup_storefront:shopRoot,ws_signup_routing_version:'1'};
 const payload={data:{type:'subscription',attributes:{custom_source:'warpedsense Mystery Cards '+lang.toUpperCase(),profile:{data:{type:'profile',attributes:{email,properties,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:cfg.list}}}}};
 let timeout;
 try{
  if(!cfg.preview){
   controller=new AbortController();timeout=setTimeout(()=>controller?.abort(),15000);
   if(!pendingSubmission||pendingSubmission.email!==email.toLowerCase()){
    pendingSubmission={email:email.toLowerCase(),id:crypto.randomUUID(),subscriptionAccepted:false};
   }
   const post=async(path,body)=>{
    const response=await fetch('https://a.klaviyo.com/client/'+path+'/?company_id='+encodeURIComponent(cfg.company),{method:'POST',headers:{'Content-Type':'application/vnd.api+json','Accept':'application/vnd.api+json','revision':'2026-10-15'},credentials:'omit',redirect:'error',referrerPolicy:'strict-origin-when-cross-origin',body:JSON.stringify(body),signal:controller.signal});
    if(response.status!==202)throw new Error(response.status===429?'rate':'request');
   };
   if(!pendingSubmission.subscriptionAccepted){
    await post('subscriptions',payload);
    pendingSubmission.subscriptionAccepted=true;
    track('signup_requested',{confirmation_required:cfg.doubleOptIn===true});
   }
   // Public Client Events API; no private key, profile lookup or claimed subscriber status.
   // Klaviyo enforces consent, delivery exclusions and the 24-hour re-entry limit.
   await post('events',{data:{type:'event',attributes:{
    unique_id:pendingSubmission.id,
    properties:{fulfillment_version:'1',language:lang,market,storefront:shopRoot,list_id:cfg.list,request_id:pendingSubmission.id},
    metric:{data:{type:'metric',attributes:{name:'Mystery Discount Requested'}}},
    profile:{data:{type:'profile',attributes:{email}}}
   }}});
   track('reward_requested',{fulfillment_version:'1'});
   pendingSubmission=null;
  }
  requestedThisPage=true;store.set(requestId,Date.now());
  form.elements.email.value='';submitting=false;go('success');syncNative();
 }catch(error){
  if(!dialog.open)return;
  track('signup_error',{error_type:error.message==='rate'?'rate_limited':error.name==='AbortError'?'timeout':'request_failed'});
  const errorEl=$('#error');if(errorEl){errorEl.textContent=error.message==='rate'?c.slow:c.error;errorEl.hidden=false}
 }finally{clearTimeout(timeout);controller=null;submitting=false;if(button.isConnected){button.disabled=false;button.removeAttribute('aria-busy')}}
}
$('.close').onclick=close;dialog.addEventListener('cancel',e=>e.preventDefault());
let replacing=false;
function nativeModal(){return [...document.querySelectorAll('[role="dialog"][aria-label="POPUP Form"]')].find(d=>d.querySelector('[data-testid="klaviyo-form-'+nativeId+'"]'))}
function replaceNative(){
 const modal=nativeModal(), closeButton=modal?.querySelector('button[aria-label="Close dialog"]');
 if(!closeButton||replacing)return;replacing=true;closeButton.click();queueMicrotask(()=>{replacing=false;open(true)});
}
function startCommonTriggers(){
 const mobile=matchMedia('(max-width: 1023px)').matches;
 let lastY=window.scrollY,stopped=false;
 const stop=()=>{if(stopped)return;stopped=true;clearTimeout(timeTrigger);clearInterval(scrollTrigger);document.removeEventListener('mouseleave',exitTrigger)};
 const trigger=()=>{triggerPending=true;if(nativeEligible()){stop();open(true)}};
 const exitTrigger=()=>{if(!mobile)trigger()};
 const timeTrigger=setTimeout(trigger,Math.max(0,8000-performance.now()));
 const scrollTrigger=setInterval(()=>{
  const y=window.scrollY,range=document.documentElement.scrollHeight-innerHeight;
  const halfway=range>0&&y/range>=0.5,quickUp=mobile&&y-lastY < -500;
  lastY=y;
  if(dialog.open||nativeAllowed||automaticHandled||signupRequested()||teaserDismissed){stop();return}
  if(triggerPending&&nativeEligible()){trigger();return}
  if(halfway||quickUp)trigger();
 },200);
 document.addEventListener('mouseleave',exitTrigger);
 window.addEventListener('pagehide',stop,{once:true});
}
function dismissTeaser(){
 teaserDismissed=true;
 store.set(dismissalId+'_teaser_closed',Date.now());
 if(dialog.open)close();
 syncNative();track('teaser_close');
}
function syncNative(){
 const teasers=document.querySelectorAll('.kl-teaser-'+nativeId);
 const previewButton=$('.preview-open');if(previewButton)previewButton.hidden=teasers.length>0||teaserDismissed||signupRequested()||privacyBlocked();
 teasers.forEach(teaser=>{
  const suppressed=teaserDismissed||signupRequested()||privacyBlocked();
  teaser.hidden=suppressed;
  teaser.toggleAttribute('data-ws-mystery-suppressed',suppressed);
  const nativeClose=teaser.querySelector('button[aria-label="Close teaser"]');
  let ownClose=teaser.querySelector('[data-ws-mystery-dismiss]');
  if(nativeClose&&ownClose){ownClose.remove();ownClose=null}
  if(!nativeClose&&!ownClose){
   ownClose=document.createElement('button');ownClose.type='button';ownClose.setAttribute('data-ws-mystery-dismiss','');
   ownClose.setAttribute('aria-label',lang==='de'?'Rabatt-Button schließen':'Close discount button');
   ownClose.textContent='×';teaser.append(ownClose);
  }
  const label=teaser.querySelector('[role="button"] p');
  if(variant==='B'&&label&&label.textContent!==c.launcher)label.textContent=c.launcher;
 });
}
document.addEventListener('click',e=>{
 if(e.target.closest?.('.kl-teaser-'+nativeId+' [data-ws-mystery-dismiss],.kl-teaser-'+nativeId+' button[aria-label="Close teaser"]')){e.preventDefault();e.stopImmediatePropagation();dismissTeaser();return}
 const teaser=e.target.closest?.('.kl-teaser-'+nativeId+' [role="button"]');
 if(teaser){e.preventDefault();e.stopImmediatePropagation();track('launcher_click',{interaction:'pointer'});open()}
},true);
document.addEventListener('keydown',e=>{
 if((e.key==='Enter'||e.key===' ')&&e.target.closest?.('.kl-teaser-'+nativeId+' [role="button"]')){e.preventDefault();e.stopImmediatePropagation();track('launcher_click',{interaction:'keyboard'});open()}
},true);
// A native portal also exists while only its teaser is active. Never close it
// from DOM mutations: interrupting that animation leaves Klaviyo's scroll lock.
// Only an actual native form-open event initiates the replacement.
window.addEventListener('klaviyoForms',e=>{
 const d=e.detail||{};
 if(d.formId!==nativeId){if(d.type==='open')store.set(anyPopupKey,Date.now());return}
 if(variant==='B'){if(d.type==='open')requestAnimationFrame(replaceNative);return}
 if(d.type==='open'){
  if(!nativeAllowed||privacyBlocked()||blocked(false)){
   internalNativeClose=true;nativeAllowed=false;document.documentElement.removeAttribute('data-ws-native-allowed');
   requestAnimationFrame(()=>{nativeModal()?.querySelector('button[aria-label="Close dialog"]')?.click();setTimeout(()=>{internalNativeClose=false},100)});
   return;
  }
  nativeOpening=false;markShown();
 }else if(d.type==='close'){
  nativeAllowed=false;nativeOpening=false;document.documentElement.removeAttribute('data-ws-native-allowed');
  if(!internalNativeClose){automaticHandled=true;store.set(dismissalId+'_closed',Date.now());track('close')}
 }else if(d.type==='submit'){
  requestedThisPage=true;store.set(requestId,Date.now());track('signup_requested');syncNative();
  if(!cfg.preview&&hasAnalyticsConsent()){
   // Native Klaviyo signup identifies the subscriber; do not copy email into analytics or storage.
   try{window.klaviyo?.identify({ws_signup_experiment:id,ws_signup_variant:'A'})?.catch?.(()=>{})}catch{}
  }
 }
});
window.addEventListener('pagehide',()=>abandon('page_exit'));
window.addEventListener('storage',e=>{if(e.key===requestId){if(signupRequested()&&dialog.open)close();syncNative()}});
const nativeStyle=document.createElement('style');nativeStyle.textContent=`html[data-ws-mystery-ready="B"] [role="dialog"][aria-label="POPUP Form"]:has([data-testid="klaviyo-form-${nativeId}"]){visibility:hidden!important}
html[data-ws-mystery-ready="A"]:not([data-ws-native-allowed]) [role="dialog"][aria-label="POPUP Form"]:has([data-testid="klaviyo-form-${nativeId}"]){visibility:hidden!important}
html[data-ws-mystery-ready="B"] .kl-teaser-${nativeId}{width:156px!important}
html[data-ws-mystery-ready="B"] .kl-teaser-${nativeId} [data-testid="animated-teaser"] > [role="button"]{border-radius:0!important;background:#000!important}
.kl-teaser-${nativeId} [role="button"] p{color:#fff!important}
.kl-teaser-${nativeId}[data-ws-mystery-suppressed]{display:none!important}
.kl-teaser-${nativeId} [data-ws-mystery-dismiss]{all:initial;box-sizing:border-box;position:absolute!important;right:2px!important;top:6px!important;width:24px!important;height:24px!important;display:flex!important;align-items:center;justify-content:center;z-index:2;cursor:pointer;background:#000;color:#fff;font:20px/1 Arial,sans-serif;border:0;border-radius:0}
.kl-teaser-${nativeId} [data-ws-mystery-dismiss]:focus-visible{outline:2px solid #fff;outline-offset:-2px}`;
let mounted=false;
function mount(){
 if(mounted)return;mounted=true;dialog.hidden=false;document.head.append(nativeStyle);document.documentElement.setAttribute('data-ws-mystery-ready',variant);
 const observer=new MutationObserver(refreshPrivacy);observer.observe(document.body,{childList:true,subtree:true});refreshPrivacy();
 if(cfg.preview&&variant==='B'){
  const launcher=document.createElement('div');launcher.className='preview-open';
  const trigger=document.createElement('button');trigger.type='button';trigger.className='preview-trigger';trigger.textContent=c.launcher;trigger.onclick=()=>open();
  const dismiss=document.createElement('button');dismiss.type='button';dismiss.className='preview-dismiss';dismiss.textContent='×';dismiss.setAttribute('aria-label',lang==='de'?'Rabatt-Button schließen':'Close discount button');dismiss.onclick=dismissTeaser;
  launcher.append(trigger,dismiss);root.append(launcher);syncNative();
 }
 window.WSMystery={variant,preview:cfg.preview,open,close};startCommonTriggers();
}
// Wait for styles before hiding/replacing any native UI; script or CSS failure leaves the control usable.
styleLink.onload=mount;styleLink.onerror=()=>host.remove();
// The stylesheet must be connected to load; the host itself has no visible content yet.
dialog.hidden=true;document.body.append(host);styleLink.addEventListener('load',()=>{dialog.hidden=false},{once:true});
})();
